import React from 'react';
import SEO from '../../components/SEO';
import BottomPostCodeSection from '../../components/BottomPostCodeSection';
import { graphql, Link } from 'gatsby';
import AllProductsCard from '../../components/AllProductsCard';
import GetSEOData from '../../data/SEO';
import BadgeHeroSection from '../../components/HeroSectionBadge';
import AnyQuestions from '../../components/AnyQuestions';
import AudienceNavigation from '../../components/AudienceNavigation';
import LitImage from '../../components/images/LitImage';
const AllProducts = ({ data }) => {
  let { title, description } = GetSEOData('all-products');
  const allProductsData = data.allDatoCmsProductPageModel.nodes[0];
  return (
    <div className="all-products-container">
      <SEO
        title={
          allProductsData.seoData.seoTitle
            ? allProductsData.seoData.seoTitle
            : title
        }
        description={
          allProductsData.seoData.seoDescription
            ? allProductsData.seoData.seoDescription
            : description
        }
        metaTags={allProductsData.seo}
      />
      <BadgeHeroSection
        heading={allProductsData.heroBanner.heading}
        subHeading={allProductsData.heroBanner.subheading}
        heroImageDesktop={allProductsData.heroBanner.featureImage}
        heroImageMobile={allProductsData.heroBanner.featureImage}
        secondaryHeroImage={allProductsData.heroBanner.featureImage}
        mode={allProductsData.heroBanner.colour}
        layout={allProductsData.heroBanner.layout}
        hidePostcodeSearch
        heroInnerNoPadding
      />
      <div className="navigation-container">
        {allProductsData?.productSections.map(
          ({ quicknavImage, quicknavHeading, quicknavBody, id }, index) => {
            return (
              <AudienceNavigation
                heading={quicknavHeading}
                image={quicknavImage}
                body={quicknavBody}
                path={id}
                index={index}
              />
            );
          },
        )}
        <div className="link-container">
          <div className="navigation-icon">
            <LitImage image={data.navigationArea} alt="blue icon" />
          </div>
          <div className="navigation-header">
            <h2>Check your area</h2>
          </div>
          <div className="navigation-content">
            <p>Check if you can get that Lit feeling</p>
          </div>
          <div className="navigation-go-section">
            <Link to="#bottomPostcode" className="navigation-link">
              Find out more
            </Link>
          </div>
        </div>
      </div>
      <div className="product-cards-container">
        {allProductsData?.productSections.map(
          (
            {
              backgroundColour,
              id,
              body,
              productList,
              featureImage,
              buttonText,
              buttonUrl,
              productIcon,
              speed,
            },
            index,
          ) => (
            <AllProductsCard
              backgroundColor={backgroundColour}
              id={id}
              body={body}
              productList={productList}
              index={index}
              image={featureImage}
              buttonText={buttonText}
              buttonUrl={buttonUrl}
              productIcon={productIcon}
              speed={speed}
            />
          ),
        )}
        <p className="speed-caveats">
          **Broadband speed calculations: The UK’s average broadband speeds are
          69.4Mbps for downloads compared to Lit Fibre’s top package average
          speed of 900Mps. Average speeds taken from Ofcom’s ‘UK Home Broadband
          Performance’ report March 2023.
        </p>
      </div>

      <BottomPostCodeSection
        heading="Are you ready to go Lit?"
        backgroundColor="Yellow"
      />
      <AnyQuestions />
    </div>
  );
};

export default AllProducts;
export const query = graphql`
  query {
    allDatoCmsProductPageModel {
      nodes {
        seo {
          description
          title
          twitterCard
          image {
            gatsbyImageData
          }
        }
        seoData {
          seoTitle
          seoDescription
        }
        heroBanner {
          heading {
            value
          }
          subheading {
            value
          }
          featureImage {
            gatsbyImageData
          }
          colour
          layout
        }
        productSections {
          backgroundColour
          id
          productIcon {
            gatsbyImageData
          }
          heading {
            value
          }
          body {
            value
          }
          speed {
            value
          }
          buttonText
          buttonUrl
          featureImage {
            gatsbyImageData
          }
          productList {
            description {
              value
            }
            icon {
              gatsbyImageData
            }
          }
          quicknavHeading {
            value
          }
          quicknavBody {
            value
          }
          quicknavImage {
            gatsbyImageData
          }
        }
      }
    }
    navigationArea: file(
      relativePath: { eq: "audience-images/audienceNavigationArrow.png" }
    ) {
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`;
